<template>
  <v-container>
    <!-- <v-card> -->
    <!-- seleccion de estados y colores-->
    <v-container>
      <h2>Estados</h2>
      <v-row>
        <v-col
          v-for="(estado, index) in selectedItem.customized.estados"
          :key="index"
          class="style-estados"
          :md="4"
          :sm="6"
        >
          <div class="style-estados-txt">
            <input
              type="checkbox"
              :id="'estado_' + index"
              v-model="estado.checked"
            />
            <label :for="'estado_' + index">{{ estado.nombre }}</label>
          </div>
          <input
            :key="estado.color"
            type="color"
            v-model="estado.color"
            @change="cambiar(color.estado, $event.target.value)"
          />
        </v-col>
      </v-row>
    </v-container>
    <!-- ------------------------------------------------------------------------ -->
    <!-- Filtro fechas -->
    <div>
      <v-container>
        <h2>Filtro fechas</h2>
        <v-row>
          <!-- Selector de fecha de inicio -->
          <!-- <v-col -->
          <!-- cols="5"
            lg="5"
          > -->
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedItem.customized.fechaInicio"
                label="Fecha Inicio"
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                @blur="fechaInicio = parseDate(dateFormatted)"
                v-on="on"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedItem.customized.fechaInicio"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
          <!-- </v-col> -->
        </v-row>
        <!-- Selector hora inicio -->
        <v-row>
          <!-- <v-col -->
          <!-- cols="5"
            lg="5"
          > -->
          <v-menu
            ref="menuHoraInicio"
            v-model="menuHoraInicio"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedItem.customized.horaInicio"
                label="Hora Inicio"
                prepend-icon="mdi-clock-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
              ></v-text-field>
            </template>
            <v-time-picker
              v-model="selectedItem.customized.horaInicio"
              @input="menuHoraInicio = false"
              format="24hr"
              min="00:00"
              max="23:59"
            ></v-time-picker>
          </v-menu>
          <!-- </v-col> -->
        </v-row>
        <!-- </v-row> -->

        <!-- Selector de FEcha de Fin -->
        <v-row>
          <!-- <v-col -->
          <!-- cols="5"
            lg="5"
          > -->
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedItem.customized.fechaFin"
                label="Fecha Fin"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedItem.customized.fechaFin"
              no-title
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <!-- </v-col> -->
        </v-row>
        <!-- Selector de hora de fin -->
        <v-row>
          <!-- <v-col
            cols="5"
            lg="5"
          > -->
          <v-menu
            ref="menuHoraFin"
            v-model="menuHoraFin"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedItem.customized.horaFin"
                label="Hora Fin"
                prepend-icon="mdi-clock-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
              ></v-text-field>
            </template>
            <v-time-picker
              v-model="selectedItem.customized.horaFin"
              @input="menuHoraFin = false"
              format="24hr"
              min="00:00"
              max="23:59"
            ></v-time-picker>
          </v-menu>
          <!-- </v-col> -->
        </v-row>
        <!-- </v-row> -->
      </v-container>
    </div>
    <!-- ------------------------------------------------------------- -->
    <!-- Seleector del formato del eje X -->
    <div>
      <v-container>
        <h2>Formato eje X</h2>
        <v-select
          v-model="selectedItem.customized.tipoEjeX"
          :items="options"
          item-text="texto"
          item-value="id"
          label="Selecciona una opción"
        ></v-select>
      </v-container>
    </div>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import { mapState } from "vuex";
// import moment from 'moment';
export default {
  data() {
    return {
      // fechaInicio: null,
      // fechaFin: null,
      dateFormatted: null,

      menu1: false,
      menu2: false,

      // horaInicio: null,
      // horaFin: null,
      menuHoraInicio: false,
      menuHoraFin: false,

      // selectedItem: { id: 1, texto: "Hora" },
      options: [
        { id: 1, texto: "Hora" },
        { id: 2, texto: "Fecha completa" },
      ],
    };
  },
  computed: {
    ...mapState(["selectedItem"]),
    computedDateFormatted() {
      return this.formatDate(this.selectedItem.customized.fechaFin);
    },
    horaFormattedInicio() {
      if (!this.selectedItem.customized.horaInicio) return null;
      const [hour, minute] = this.selectedItem.customized.horaInicio.split(":");
      return `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`;
    },
    horaFormattedFin() {
      if (!this.selectedItem.customized.horaFin) return null;
      const [hour, minute] = this.selectedItem.customized.horaFin.split(":");
      return `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`;
    },
  },

  watch: {
    fechaInicio() {
      // console.log('cambio fecha inicio');
      this.dateFormatted = this.formatDate(this.selectedItem.customized.fechaInicio);
      this.cambiarFechaIni(this.selectedItem.customized.fechaInicio);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.color-square {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.style-estado {
  display: flex;
  align-items: center; /* Centra verticalmente los elementos */
}

.estado-txt {
  margin-left: 10px; /* Ajusta el espacio entre el input de color y el checkbox */
}
</style>
